import axios from "axios";
import { DEVICE_SERVICE_BASE } from '../constants';
import { getHeaders } from './AuthService';

export const sendControls = async (siteId, equipmentId, controls) => {
    let results = await axios.put(`${DEVICE_SERVICE_BASE()}/controls/sites/${siteId}/equipment/${equipmentId}`, 
    {
        "updates":  controls
    },
    {
        headers: await getHeaders(),
        crossDomain: true
    })
    return results.data;
  };
